import type { Vehicle, VehicleDerivative } from '..';

// Helper function to check if it's a VehicleDerivative
export const isVehicleDerivative = (
    vehicle: Vehicle | VehicleDerivative
): vehicle is VehicleDerivative => {
    return 'type' in vehicle && vehicle.type === 'derivative';
};

// Helper function to check if it's a Vehicle
export const isVehicle = (vehicle: Vehicle | VehicleDerivative | null): vehicle is Vehicle => {
    return (
        vehicle !== null &&
        'type' in vehicle &&
        vehicle.type === 'vehicle' &&
        'current_status' in vehicle
    );
};
